import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { reduxFormInputType } from "custom-prop-types";
import styles from "components/settings/user-settings.scss";
import { Button } from "components/common/button";

const StatelessUserNameForm = ({ onSaveUserName }) => (
  <div className={ styles["form-container"] }>
    <form onSubmit={ (e) => { e.preventDefault(); onSaveUserName(); } }>
      <h2>Change your name:</h2>
      { renderFormElement("First Name", "name") }
      { renderFormElement("Last Name", "surname") }
      <Button primary type="submit">Save Changes</Button>
    </form>
  </div>
);

StatelessUserNameForm.propTypes = {
  onSaveUserName: PropTypes.func.isRequired
};

export const UserNameForm = reduxForm({ form: "userNameForm" })(StatelessUserNameForm);

const StatelessEmailForm = ({
  email,
  onSaveUserEmail
}) => (
  <div className={ styles["form-container"] }>
    <form onSubmit={ (e) => { e.preventDefault(); onSaveUserEmail(); } }>
      <h2>Change your email:</h2>
      <div>Your current email address is: <strong>{ email }</strong></div>
      <div>
        { renderFormElement("New Email", "newEmail") }
        { renderFormElement("Confirm Email", "confirmEmail") }
        <Button primary type="submit">Save Changes</Button>
      </div>
    </form>
  </div>
);

StatelessEmailForm.propTypes = {
  email: PropTypes.string.isRequired,
  onSaveUserEmail: PropTypes.func.isRequired
};

export const UserEmailForm = reduxForm({ form: "userEmailForm" })(StatelessEmailForm);

const renderFormElement = (title, name) => (
  <div className={ styles["fields-container"] }>
    <h4>{ title }</h4>
    <Field
      component={ textInput }
      name={ name }
      placeholder={ title }
    />
  </div>
);

const textInput = (props) => (
  <div className={ styles["fields-container__row"] }>
    <input { ...props.input } className={ styles.fields } placeholder={ props.placeholder } />
  </div>
);

textInput.propTypes = {
  input: reduxFormInputType.isRequired,
  placeholder: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/user-name-and-email-forms.jsx